import {Button, Card, CardActions, CardContent, colors, Modal, Theme, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import {T} from 'react-polyglot-hooks';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '90%',
    overflowY: 'auto',
    maxWidth: '95%'
  },
  container: {
    marginTop: theme.spacing(3)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  deleteButton: {
    color: theme.palette.white,
    backgroundColor: colors.red[600],
    '&:hover': {
      backgroundColor: colors.red[900]
    }
  },
  submitButton: {
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900]
    }
  }
}));

const ConfirmModal = (props: {
  className?: string,
  onClose: () => void,
  onConfirmClick: () => void,
  onCancelClick?: () => void,
  open: boolean,
  title: string,
  message: string,
  confirm?: string,
  cancel?: string,
  submitIsDelete?: boolean
}) => {
  const {open, onClose, onConfirmClick, onCancelClick, title, message, className, confirm, submitIsDelete, cancel, ...rest} = props;
  const classes = useStyles();

  if (!open) {
    return null;
  }

  return (
      <Modal onClose={onClose} open={open}>
        <Card {...rest} className={clsx(classes.root, className)}>
          <form>
            <CardContent>
              <Typography gutterBottom variant="h3">{title}</Typography>
              <Typography gutterBottom variant="body1">{message}</Typography>
            </CardContent>
            <CardActions className={classes.actions}>
              <Button onClick={() => {
                onClose();
                if (onCancelClick) onCancelClick();
              }} variant="contained">
                {cancel}
                {!cancel && (<T phrase="Cancel"/>)}
              </Button>
              <Button className={submitIsDelete ? classes.deleteButton : classes.submitButton} onClick={() => {
                onClose();
                onConfirmClick();
              }} variant="contained">
                {confirm}
                {!confirm && (<T phrase="Confirm"/>)}
              </Button>
            </CardActions>
          </form>
        </Card>
      </Modal>
  );
};

export default ConfirmModal;
